export var cubic = value => Math.pow(value, 3);
export var uniq = arr => [...new Set(arr)];
export var dt = (value, defaultText) => value == null ? defaultText : value;
export var linear = value => value;
export var isHTMLSupportImage = val => {
  if (val == null) {
    return false;
  }
  return val.startsWith('data:image') || /\.(png|jpg|gif|jpeg|svg)$/.test(val);
};
export var isHTMLSupportVideo = val => {
  if (val == null) {
    return false;
  }
  return val.startsWith('data:video') || /\.(mp4|webm|ogg)$/.test(val);
};
export var easeInOutCubic = value => value < 0.5 ? cubic(value * 2) / 2 : 1 - cubic((1 - value) * 2) / 2;
export var isString = val => typeof val === 'string';
export var toNumber = val => {
  if (val == null) return 0;
  if (isString(val)) {
    val = parseFloat(val);
    val = Number.isNaN(val) ? 0 : val;
    return val;
  }
  if (isBool(val)) return Number(val);
  return val;
};
export var isBool = val => typeof val === 'boolean';
export var isFunction = val => typeof val === 'function';
export var isNumber = val => typeof val === 'number';
export var isPlainObject = val => Object.prototype.toString.call(val) === '[object Object]';
export var isObject = val => typeof val === 'object' && val !== null;
export var isArray = val => Array.isArray(val);
export var isURL = val => {
  if (!val) {
    return false;
  }
  return /^(http)|(\.*\/)/.test(val);
};
export var isEmpty = val => val === undefined || val === null || val === '' || Array.isArray(val) && !val.length;
export var removeItem = (arr, item) => {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1);
    }
  }
};
export var throttle = function (method, mustRunDelay) {
  if (mustRunDelay === void 0) {
    mustRunDelay = 200;
  }
  var timer;
  var start = 0;
  return function loop() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var now = Date.now();
    var elapsed = now - start;
    if (!start) {
      start = now;
    }
    if (timer) {
      window.clearTimeout(timer);
    }
    if (elapsed >= mustRunDelay) {
      method.apply(this, args);
      start = now;
    } else {
      timer = window.setTimeout(() => {
        loop.apply(this, args);
      }, mustRunDelay - elapsed);
    }
  };
};
export var debounce = function (method, delay) {
  if (delay === void 0) {
    delay = 200;
  }
  var timer;
  return function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    timer && window.clearTimeout(timer);
    timer = window.setTimeout(() => {
      method.apply(this, args);
    }, delay);
  };
};
export function kebabCase(str) {
  var reg = /([^-])([A-Z])/g;
  return str.replace(reg, '$1-$2').replace(reg, '$1-$2').toLowerCase();
}
export var camelize = s => s.replace(/-(\w)/g, (_, p) => p.toUpperCase());
export var bigCamelize = s => camelize(s).replace(s.charAt(0), s.charAt(0).toUpperCase());
export var range = (num, left, right) => {
  if (num < left) {
    return left;
  }
  if (num > right) {
    return right;
  }
  return num;
};
export var delay = time => new Promise(resolve => setTimeout(resolve, time));
export var inBrowser = () => typeof window !== 'undefined';
export var createCache = max => {
  var cache = [];
  return {
    cache,
    has(key) {
      return this.cache.includes(key);
    },
    add(key) {
      if (this.has(key)) {
        return;
      }
      this.cache.length === max && cache.shift();
      this.cache.push(key);
    },
    remove(key) {
      this.has(key) && removeItem(this.cache, key);
    },
    clear() {
      this.cache.length = 0;
    }
  };
};
export var NOOP = () => {};
export function chunk(array, size) {
  var chunked = [];
  var index = 0;
  while (index < array.length) {
    chunked.push(array.slice(index, index + size));
    index += size;
  }
  return chunked;
}